<template>
  <div class="initiate-action-table-cell">
      <div class="active_not_active" slot="buttonContent">
        <v-btn small class='active_not_active_btn' slot="buttonContent" @click="editActivationOfEmployee()" text>
          <v-icon class="material-icons-round">swap_horiz</v-icon>
        </v-btn>
      </div>
      <div class="edit" slot="buttonContent">
        <v-btn small class='edit_btn' slot="buttonContent" @click="navigateToEditEmployee()" text>
          <img :src="editIcon" alt="" />
        </v-btn>
      </div>
      <div class="delete" :class="{ disabled : isCurrentConnectedUser }" slot="buttonContent">
        <v-btn small class='delete_btn' :disabled="isCurrentConnectedUser" slot="buttonContent" @click="deleteServiceProviderEmployee()" text>
          <img v-if='!isCurrentConnectedUser' :src="deleteIcon" alt="" />
          <img v-else :src="disabledDeleteIcon" alt="" />
        </v-btn>
      </div>
    <YesNoPopup
      :message='popUpMessage'
      title="edit.service.provider.employee.profile.delete.pop.up.title"
      no-caption="edit.service.provider.employee.profile.delete.pop.up.no"
      yes-caption="edit.service.provider.employee.profile.delete.pop.up.yes"
      :visible-popup='visiblePopUp'
      @clicked='onClickYesNoButton'
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import deleteIcon from '@/assets/delete.svg';
import disabledDeleteIcon from '@/assets/delete_disabled.svg';
import editIcon from '@/assets/icons/pencil_icon@1x.svg';
import YesNoPopup from '@/components/popup/YesNoPopup.vue';

export default {
  name: 'ActionsTableCell',
  components: {
    YesNoPopup,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visiblePopUp: false,
    };
  },
  computed: {
    ...mapGetters(['profile']),
    isCurrentConnectedUser() {
      return this.item.uid === this.profile?.id;
    },
    popUpMessage() {
      let text = ` ${this.$t('edit.service.provider.employee.profile.delete.pop.up')} `;
      text += this.item.email;
      text += ` ${this.$t('edit.service.provider.employee.profile.delete.pop.up.continue')} \r\n`;
      text += this.$t('edit.service.provider.employee.profile.delete.pop.up.irreversible');
      return text;
    },
    deleteIcon() {
      return deleteIcon;
    },
    editIcon() {
      return editIcon;
    },
    disabledDeleteIcon() {
      return disabledDeleteIcon;
    },
  },
  methods: {
    async onClickYesNoButton(value) {
      this.visiblePopUp = false;
      if (value) {
        await this.$emit('deleteServiceProviderEmployee', this.item.uid);
      }
    },
    async editActivationOfEmployee() {
      await this.$emit('editActivationOfEmployee', this.item.uid);
    },
    async navigateToEditEmployee() {
      await this.$emit('navigateToEditEmployee', this.item.uid);
    },
    async deleteServiceProviderEmployee() {
      this.visiblePopUp = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";
.v-btn:not(.v-btn--round).v-size--small {
  min-width: 28px;
  width: 28px !important;
}
.initiate-action-table-cell {
  display: flex;
  margin-top: 15%;
  justify-content: space-between;
  .delete {
    align-items: center;
    background-color: #FBE9EE;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    height: 28px;
    justify-content: center;
    width: 28px;
    &.disabled {
      background: #dddddd;
      opacity: 0.5;
      cursor: default;
    }
  }
  .edit {
    align-items: center;
    background-color: #EDF5FD;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    height: 28px;
    justify-content: center;
    width: 28px;
  }
  .active_not_active {
    &_btn{
      color: $default-fill-color !important;
    }
    align-items: center;
    background-color: #EDF5FD;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    height: 28px;
    justify-content: center;
    width: 28px;
  }
}
</style>
